import { render, staticRenderFns } from "./clsBtn.vue?vue&type=template&id=7c0a4e86&scoped=true"
import script from "./clsBtn.vue?vue&type=script&lang=js"
export * from "./clsBtn.vue?vue&type=script&lang=js"
import style0 from "./clsBtn.vue?vue&type=style&index=0&id=7c0a4e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0a4e86",
  null
  
)

export default component.exports